import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import type { PreviewContext } from '../preview.types';
import { getBodyPreviewData } from '../preview-style.resolver';
import { Button } from '@app/shared/components/form-fields/button/button';
import { QuestionType } from '@app/core/enums/questionnaire.enums';
import { ChoiceBased } from '@app/features/questionnaire/components/question-type/choice-based/choice-based';
import { TextInput } from '@app/features/questionnaire/components/question-type/text-input/text-input';
import { Sliders } from '@app/features/questionnaire/components/question-type/sliders/sliders';
import { RatingScale } from '@app/features/questionnaire/components/question-type/rating-scale/rating-scale';
import { Nps } from '@app/features/questionnaire/components/question-type/nps/nps';
import { RankOrder } from '@app/features/questionnaire/components/question-type/rank-order/rank-order';
import { SocialReview } from '@app/features/questionnaire/components/question-type/social-review/social-review';
import { InputText } from '@app/shared/components/form-fields/input-text/input-text';
import { DatePicker } from '@app/shared/components/form-fields/date-picker/date-picker';
import { Number } from '@app/shared/components/form-fields/number/number';
import { MobileNumber } from '@app/shared/components/form-fields/mobile-number/mobile-number';

@Component({
  selector: 'app-body-content-preview',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    Button,
    ChoiceBased,
    TextInput,
    Sliders,
    RatingScale,
    Nps,
    RankOrder,
    SocialReview,
    InputText,
    Number,
    MobileNumber,
    DatePicker


  ],
  templateUrl: './body-content-preview.html',
  styleUrl: './body-content-preview.scss',
})
export class BodyContentPreviewComponent {
  @Input() context: PreviewContext | null = null;
  @Input() viewMode: 'web' | 'mobile' = 'web';
  @Output() addQuestionClick = new EventEmitter<void>();
  @Output() previousPage = new EventEmitter<void>();
  @Output() nextPage = new EventEmitter<void>();
  @Output() goToPage = new EventEmitter<number>();

  questionType = QuestionType;

  get data() {
    return getBodyPreviewData(this.context);
  }

  onAddQuestion(): void {
    this.addQuestionClick.emit();
  }

  onPrevious(): void {
    this.previousPage.emit();
  }

  onNext(): void {
    this.nextPage.emit();
  }

  onSkipUserInfo(): void {
    this.nextPage.emit();
  }

  onPageSelect(value: number): void {
    this.goToPage.emit(value);
  }

  /** Map user info field type to HTML input type for preview form. */
  getUserInfoInputType(fieldType: string): string {
    if (!fieldType) return 'text';
    const t = fieldType.toUpperCase();
    if (t === 'EMAIL') return 'email';
    if (t === 'NUMBER') return 'number';
    if (t === 'PHONE') return 'tel';
    return 'text';
  }
}
